import { useNavigate } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import {
  Container,
  Alert,
  Text
} from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import { useSession } from '../api';
import SellerRegistrationForm from '../components/seller/SellerRegistrationForm';

const SellerRegistrationPage = () => {
  const { isSeller } = useSession();
  const navigate = useNavigate();

  if (isSeller) {
    return (
      <ProtectedRoute requireAuth={true} redirectTo="/">
        <Container size="lg" py="xl">
        <Alert
          icon={<IconExclamationCircle size="1rem" />}
          color="pink"
          title="You're Already a Seller"
        >
          <Text>
            You already have a seller account. You can manage your products and view your
            seller dashboard from the navigation menu.
          </Text>
        </Alert>
      </Container>
      </ProtectedRoute>
    );
  }

  const handleSuccess = () => {
    // Navigate to seller dashboard after successful registration
    navigate('/seller');
  };

  const handleCancel = () => {
    // Navigate back to home page
    navigate('/');
  };

  return (
    <ProtectedRoute requireAuth={true} redirectTo="/">
      <SellerRegistrationForm
      onSuccess={handleSuccess}
      onCancel={handleCancel}
      />
    </ProtectedRoute>
  );
};

export default SellerRegistrationPage;
